//---------------------------------------------------
//  Nom du fichier : Grades.js 
//
//  Description: Fichier utilitaires qui sert à
//               traduire les grade entre american et european
//               et trouver le sort_order selon la langue 
//               (pour la rechercher entre tel et tel grade)              
//
//  Auteur: Alek Del Balso
//---------------------------------------------------

export const sections = [
    ["vb", "v0", "v1", "3", "4-", "4", "4+"],
    ["v2", "v3", "5+", "6A", "6A+"],
    ["v4", "v5", "6B", "6B+", "6C", "6C+"],
    ["v6", "v7", "7A", "7A+"],
    ["v8", "v9", "7B", "7C"],
    ["v10", "v11", "7C+", "8A"],
    ["v12", "v13", "8A+", "8B"],
    ["v14", "v15", "8B+", "8C"],
    ["v16", "v17", "8C+", "9A"]
];

export const path_dict = ["01", "23", "45", "67", "89", "1011", "1213", "1415", "1617"];

export const am_to_eu = {
                "vb" : ["3"],
                "v0" : ["4-","4","4+"],
                "v1" : ["5"],
                "v2" : ["5+"],
                "v3" : ["6A","6A+"],
                "v4" : ["6B","6B+"],
                "v5" : ["6C","6C+"],
                "v6" : ["7A"],
                "v7" : ["7A+"],
                "v8" : ["7B"],
                "v9" : ["7C"],
                "v10" : ["7C+"],
                "v11" : ["8A"],
                "v12" : ["8A+"],
                "v13" : ["8B"],
                "v14" : ["8B+"],
                "v15" : ["8C"],
                "v16" : ["8C+"],
                "v17" : ["9A"],
};

export const eu_to_am = {
    "3": "vb",
    "4-": "v0",
    "4": "v0",
    "4+": "v0",
    "5": "v1",
    "5+": "v2",
    "6A": "v3",
    "6A+": "v3",
    "6B": "v4",
    "6B+": "v4",
    "6C": "v5",
    "6C+": "v5",
    "7A": "v6",
    "7A+": "v7",
    "7B": "v8",
    "7C": "v9",
    "7C+": "v10",
    "8A": "v11",
    "8A+": "v12",
    "8B": "v13",
    "8B+": "v14",
    "8C": "v15",
    "8C+": "v16",
    "9A": "v17"
};

  export const american = [
    "vb","v0","v1","v2","v3","v4","v5","v6","v7","v8","v9","v10","v11","v12","v13","v14","v15","v16","v17"
  ]

  export const european = [
    "3","4-","4","4+","5","5+","6A","6A+","6B","6B+","6C","6C+","7A","7A+","7B","7C","7C+","8A","8A+","8B","8B+","8C","8C+","9A" 
  ];


export const translate_grade = (grade_type, grade) => {
    if (grade_type === "american") {
        if (eu_to_am[grade]) return eu_to_am[grade];
        else return grade;
    } else {
        if (am_to_eu[grade]) {
          let grades = am_to_eu[grade]
          return grades[0];
        }
        else return grade;
    }
}
  

export const gradeToSortOrder = {
  "vb": 1,
  "3": 1,
  "v0": 2,
  "4-": 2,
  "4": 3,
  "4+": 4,
  "v1": 5,
  "5": 5,
  "v2": 6,
  "5+": 6,
  "v3": 7,
  "6A": 7,
  "6A+": 8,
  "v4": 9,
  "6B": 9,
  "6B+": 10,
  "v5": 11,
  "6C": 11,
  "6C+": 12,
  "v6": 13,
  "7A": 13,
  "v7": 14,
  "7A+": 14,
  "v8": 15,
  "7B": 15,
  "v9": 16,
  "7C": 16,
  "v10": 17,
  "7C+": 17,
  "v11": 18,
  "8A": 18,
  "v12": 19,
  "8A+": 19,
  "v13": 20,
  "8B": 20,
  "v14": 21,
  "8B+": 21,
  "v15": 22,
  "8C": 22,
  "v16": 23,
  "8C+": 23,
  "v17": 24,
  "9A": 24
};